export class ChatMessage {
  message: string = "";
  isUser: boolean = false;
  message_id: string = "";
  rating: number = 0;
  comment: string = '';

  constructor(message: string = '', isUser: boolean = false, message_id: string = "") {
    this.message = message;
    this.isUser = isUser;
    this.message_id = message_id;
  }
}
